<template>
  <div class="section-wrap" id="activities-modal-template">
    <div class="loop-tbl" v-for="(activity, index) in activities" :key="activity.seq">
      <div class="multi-item-title mt-40" v-if="index === 0">
        <h3 class="section-title">주요활동/사회공헌</h3>
        <div class="check-util">
          <div class="check-wrap"><input type="checkbox" id="chk3" v-model="activityUseYn" true-value="N" false-value="Y" title="활동 사항 없음 선택"><label for="chk3"><span>활동 사항 없음</span></label></div>
          <button type="button" class="btn btn-line-box btn-sm" @click="reset(index)">
            <i class="ico ico-refresh"></i>
            입력항목 초기화
          </button>
        </div>
      </div>
      <div class="multi-item-title mt-40" v-else>
        <h3 class="section-title ">추가 정보 {{ index }}</h3>
        <div class="check-util">
          <button type="button" class="btn btn-line-box btn-sm" @click="reset(index)">
            <i class="ico ico-refresh"></i>
            입력항목 초기화
          </button>
          <button type="button" class="btn btn-line-box btn-sm" @click="del(index)">
            <i class="ico ico-trash"></i>
            삭제하기
          </button>
        </div>
      </div>
      <div class="table-wrap">
        <table class="table-body-only">
          <caption>활동정보 표</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px;" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px;" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">활동구분<span class="must">*</span></th>
              <td>
                <div class="input-area mo-size wid400">
                  <select title="활동구분 선택" v-model="activity.actCd" :disabled="isDisabled">
                    <option value="">활동구분 선택</option>
                    <option v-for="activitiesCode in activitiesCodes" :key="activitiesCode.code" :value="activitiesCode.code">{{ activitiesCode.name }}</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">활동기간</th>
              <td>
                <div class="input-group period-setting">
                  <div class="start-day">
                    <div class="input-area mo-size">
                      <select name="startYear" id="startYear" title="시작년도선택" v-model="activity.stYear" :disabled="isDisabled">
                        <option value="">시작년도 선택</option>
                        <option v-for="year in years" :key="year" :value="year">{{ year }}년</option>
                      </select>
                    </div>
                    <div class="dash">-</div>
                    <div class="input-area mo-size">
                      <select name="startMonth" id="startMonth" title="시작월선택" v-model="activity.stMonth" :disabled="isDisabled">
                        <option value="" disabled selected hidden>시작월 선택</option>
                        <option value="01">1월</option>
                        <option value="02">2월</option>
                        <option value="03">3월</option>
                        <option value="04">4월</option>
                        <option value="05">5월</option>
                        <option value="06">6월</option>
                        <option value="07">7월</option>
                        <option value="08">8월</option>
                        <option value="09">9월</option>
                        <option value="10">10월</option>
                        <option value="11">11월</option>
                        <option value="12">12월</option>
                      </select>
                    </div>
                  </div>
                  <div class="dash">~</div>
                  <div class="end-day">
                    <div class="input-area mo-size">
                      <select name="endYear" id="endYear" title="종료년도선택" v-model="activity.edYear" :disabled="isDisabled">
                        <option value="">종료년도 선택</option>
                        <option v-for="year in years" :key="year" :value="year">{{ year }}년</option>
                      </select>
                    </div>
                  <div class="dash">-</div>
                  <div class="input-area mo-size">
                    <select name="endMonth" id="endMonth" title="종료월선택" v-model="activity.edMonth" :disabled="isDisabled">
                      <option value="" disabled selected hidden>종료월 선택</option>
                      <option value="01">1월</option>
                      <option value="02">2월</option>
                      <option value="03">3월</option>
                      <option value="04">4월</option>
                      <option value="05">5월</option>
                      <option value="06">6월</option>
                      <option value="07">7월</option>
                      <option value="08">8월</option>
                      <option value="09">9월</option>
                      <option value="10">10월</option>
                      <option value="11">11월</option>
                      <option value="12">12월</option>
                    </select>
                  </div>
                </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">기관/장소</th>
              <td>
                <div class="input-area mo-size wid400">
                  <input type="text" placeholder="입력하세요" v-model="activity.compnm" :disabled="isDisabled" title="입력하세요" @input="limitBytes($event, activity, 'compnm', 100, '기관/장소')" />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">활동내용</th>
              <td>
                <div class="textarea-wrap">
                  <textarea class="text-area-wrap" v-model="activity.actDesc" :disabled="isDisabled" title="결과 입력" @input="limitBytes($event, activity, 'actDesc', 4000, '활동내용')"></textarea>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Add Resume Card -->
    <div class="flex flex-direction align-items-center mt-40">
      <button type="button" class="add-resume-icon" @click="add" :disabled="isDisabled">
        <i class="ico ico-plus48"></i>
        <p>추가하기</p>
      </button>
      <p>클릭하여 추가 정보를 입력하실 수 있습니다.</p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Axios from 'axios';
import { apiHandler, byteLimitMixin } from './resume-common';

export default({
  name: 'activities-modal-template',
  mixins: [byteLimitMixin],
  props: ['activitiesModal', 'indbankNo', 'activitiesCodes'],
  data() {
    return {
      activities: [],
      activityUseYn: 'N', // 기본값을 'N'으로 설정
      years: [],
      activity: {
        actCd: '',
        actperSt: '',
        actperEd: '',
        compnm: '',
        actDesc: '',
        stYear: '',
        stMonth: '',
        edYear: '',
        edMonth: '',
      },
      isDisabled: false,
    };
  },
  watch: {
    activitiesModal: {
      handler(newVal) {
        if (newVal) {
          if (this.indbankNo) {
            this.getActivities();
            this.getBasic(); // 기본 정보 로드 추가
          } else {
            this.activities.push(this.activity);
          }
        }
      },
      immediate: true,
    },
    activityUseYn: {
      handler(newVal) {
        this.isDisabled = (newVal === 'N');
      },
      immediate: true,
    },
  },
  methods: {
    getActivities() {
      Axios.get(`/api/idb/${this.indbankNo}/activities`).then((response) => {
        if (response.data.success === 'R') {
          this.activities = response.data.data.map((activity) => {
            const newActivity = {
              ...activity,
              stYear: '',
              stMonth: '',
              edYear: '',
              edMonth: '',
            };
            if (!newActivity.actCd) {
              newActivity.actCd = '';
            }
            // 6자리 YYYYMM 형식 데이터를 연도/월로 분리
            if (activity.actperSt && activity.actperSt.length === 6) {
              newActivity.stYear = activity.actperSt.substr(0, 4);
              newActivity.stMonth = activity.actperSt.substr(4, 2);
            }
            if (activity.actperEd && activity.actperEd.length === 6) {
              newActivity.edYear = activity.actperEd.substr(0, 4);
              newActivity.edMonth = activity.actperEd.substr(4, 2);
            }
            return newActivity;
          });
          if (this.activities.length === 0) this.activities.push({ actCd: '', stYear: '', stMonth: '', edYear: '', edMonth: '' });
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    getBasic() {
      Axios.get(`/api/idb/${this.indbankNo}/basic`).then((response) => {
        if (response.data.success === 'R') {
          this.activityUseYn = response.data.data.activityUseYn || 'N';
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    updateActivities() {
      if (this.vaildCheck() && confirm('저장하시겠습니까?')) {
        let params = [];
        if (this.activityUseYn === 'Y') {
          params = this.activities.map((activity) => {
            const newActivity = { ...activity };
            // 연도/월을 6자리 YYYYMM 형식으로 조합
            newActivity.actperSt = `${activity.stYear}${activity.stMonth}`;
            newActivity.actperEd = `${activity.edYear}${activity.edMonth}`;
            return newActivity;
          });
        }

        Axios.post(`/api/idb/${this.indbankNo}/activities`, { activityUseYn: this.activityUseYn, activities: params }).then((response) => {
          apiHandler.handleSaveSuccess(response, (res) => {
            // 완성도 업데이트 (올바른 경로로 접근)
            if (res.data && res.data.data.completionRate !== undefined) {
              this.$emit('update:CompletionRate', res.data.data.completionRate);
            }
          });
        }).catch((e) => {
          apiHandler.handleError(e);
        });
      }
    },
    vaildCheck() {
      if (this.activityUseYn === 'Y') {
        return this.activities.every((activity) => {
          console.log(activity);
          if (!activity.actCd) {
            alert('활동구분을 선택해주세요.');
            return false;
          }

          if (!activity.stYear || !activity.stMonth) {
            alert('활동기간 시작 년, 월을 선택해주세요.');
            return false;
          }

          if (activity.edYear) {
            if (!activity.edMonth) {
              alert('활동기간 종료 월을 선택해주세요.');
              return false;
            }

            // 시작 날짜와 종료 날짜 비교
            const startDate = new Date(`${activity.stYear}-${activity.stMonth}-01`);
            const endDate = new Date(`${activity.edYear}-${activity.edMonth}-01`);

            if (endDate < startDate) {
              alert('종료 날짜가 시작 날짜보다 이전일 수 없습니다.');
              return false;
            }
          }
          return true;
        });
      }
      return true;
    },
    add() {
      this.activities.push({
        actCd: '',
        actperSt: '',
        actperEd: '',
        compnm: '',
        actDesc: '',
        stYear: '',
        stMonth: '',
        edYear: '',
        edMonth: ''
      });
    },
    reset(index) {
      const message = '입력하신 내용을 초기화하시겠습니까?';

      if (confirm(message)) {
        // 모든 항목에 대해 입력값만 초기화
        const resetActivity = {
          actCd: '',
          actperSt: '',
          actperEd: '',
          compnm: '',
          actDesc: '',
          stYear: '',
          stMonth: '',
          edYear: '',
          edMonth: '',
        };
        Vue.set(this.activities, index, resetActivity);
      }
    },
    resetAll() {
      // 전체 초기화: '활동 사항 없음' 체크박스 해제
      this.activityUseYn = 'Y'; // 기본값: 활동 사항 있음 (체크박스 해제)

      // 모든 활동 데이터 초기화
      this.activities = [];

      // 기본 한 개 항목 추가
      this.add();

      // 비활성화 상태 초기화 (입력 가능 상태)
      this.isDisabled = false;
    },
    del(index) {
      if (confirm('해당 추가정보를 삭제 하시겠습니까?')) {
        this.activities.splice(index, 1);
      }
    },
    getYearArray() {
      const currentYear = new Date().getFullYear();
      for (let i = 1900; i <= currentYear; i += 1) {
        this.years.push(i);
      }
    },
  },
  mounted() {
    this.getYearArray();
  },
});
</script>



// WEBPACK FOOTER //
// Activities.vue?3f254626